// Sizes in rem
export const summaryTitleSize = 2.5;
export const titleSize = 1.75;
export const sizetitleSize = 1.75;
export const subtitleSize = 1.5;
